import styled from 'styled-components'
import coinbase from '../assets/icons/coinbaseWalletIcon.svg'
import metamask from '../assets/icons/metamask.svg'
import walletConnect from '../assets/icons/walletConnect.svg'
import wallet from '../assets/icons/wallet.svg'

const Logo = styled.img`
    width: 25px;
    height: 25px;
`

const LOGO_MAP = {
    MetaMask: metamask,
    'Coinbase Wallet': coinbase,
    WalletConnect: walletConnect,
}
export const WalletLogo = ({ walletType }: { walletType: string }) => {
    const logo = LOGO_MAP[walletType] ?? wallet
    return <Logo src={logo} />
}
